<template>
    <section class="infographic light purple">
        <circles-layout></circles-layout>
        <div class="blocks-wrapper">
            <div class="block" ref="block">
                <h3>Medewerkers</h3>
                <div class="rings-wrapper">
                    <div>
                        <div class="solid-circle">
                            <p>1.270</p>
                        </div>
                        <p>Aantal</p>
                    </div>
                    <div>
                        <progress-ring :value="vrouw"></progress-ring>
                        <p>Vrouw</p>
                    </div>
                    <div>
                        <progress-ring :value="man"></progress-ring>
                        <p>Man</p>
                    </div>
                </div>
                <h3>FTE</h3>
                <p>Totaal - 987,1 fte</p>
                <progress-bar :value="total" :max="987.1"></progress-bar>
                <p>Mbo - 559,8 fte</p>
                <progress-bar :value="mbo" :max="987.1"></progress-bar>
                <p>Vo - 150,6 fte</p>
                <progress-bar :value="vo" :max="987.1"></progress-bar>
                <p>Educatie - 32 fte</p>
                <progress-bar :value="educatie" :max="987.1"></progress-bar>
                <p>Niet-onderwijsgevend personeel - 244,7 fte</p>
                <progress-bar :value="diensten" :max="987.1"></progress-bar>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    import ProgressRing from '@/app/components/progressRing';
    import ProgressBar from '@/app/components/progressBar';

    import { gsap } from 'gsap';

    export default {
        name: 'Info1',
        meta: {
            title: 'Info1',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles,
            'progress-ring': ProgressRing,
            'progress-bar': ProgressBar
        },
        data()
        {
            return {
                vrouw: 64,
                man: 36,
                total: 987.1,
                mbo: 559.8,
                vo: 150.6,
                educatie: 32,
                diensten: 244.7
            };
        },
        mounted()
        {
            this.tl = gsap.timeline({ paused: true });
            this.tl.from( this.$refs.block, { y: 100, autoAlpha: 0, duration: 0.2 }, 0 );
            this.tl.from( this, { vrouw: 0, duration: 1, roundProps: 'vrouw' }, 0 );
            this.tl.from( this, { man: 0, duration: 1, roundProps: 'man' }, 0.1 );
            this.tl.from( this, { total: 0, duration: 1 }, 1 );
            this.tl.from( this, { mbo: 0, duration: 1 }, 1.1 );
            this.tl.from( this, { vo: 0, duration: 1 }, 1.2 );
            this.tl.from( this, { educatie: 0, duration: 1 }, 1.4 );
            this.tl.from( this, { diensten: 0, duration: 1 }, 1.6 );
        },
        methods: {
            focus()
            {
                this.tl.play();
            },
            blur()
            {
                this.tl.reverse();
            }
        }
    };
</script>
